import React from 'react';
import { cn } from '@/lib/utils';

export const AdminPageHeader = ({ title, description, actions, className }) => (
  <div className={cn('flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8', className)} data-testid="admin-page-header">
    <div>
      <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">{title}</h1>
      {description && <p className="mt-1 text-sm text-muted-foreground max-w-2xl">{description}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);
